import { __awaiter, __generator } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, Fragment as _Fragment } from "vue";
var _hoisted_1 = { class: "application" };
var _hoisted_2 = {
    key: 1,
    class: "application__exist-page application__page"
};
var _hoisted_3 = ["innerHTML"];
var _hoisted_4 = {
    key: 0,
    href: "https://www.barganets.com",
    target: "_blank",
    class: "application__exist-page-site"
};
var _hoisted_5 = { class: "follow" };
var _hoisted_6 = {
    key: 2,
    class: "application__banner"
};
var _hoisted_7 = ["src"];
var _hoisted_8 = {
    key: 3,
    class: "application__start-page application__page"
};
var _hoisted_9 = { class: "application__start-page-confirm" };
var _hoisted_10 = {
    key: 4,
    class: "application__tabs"
};
import { ref, onMounted, computed } from 'vue';
import { useApplication, useUser } from '@/composables';
import { useTelegramStore } from '@/store';
import { useAuthStore } from '@/store';
import ApplicationHeader from '@/components/ApplicationHeader.vue';
import ApplicationTabs from '@/components/ApplicationTabs.vue';
import bannerImage from '@/assets/images/banner-image.png';
import arrowTopRight from '@/assets/icons/arrow-top-right.svg';
import router from '@/router';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ApplicationView',
    setup: function (__props) {
        var _this = this;
        var checkApplication = useApplication().checkApplication;
        var stopUserTariff = useUser().stopUserTariff;
        var telegramStore = useTelegramStore();
        var authStore = useAuthStore();
        var startFilling = ref(false);
        var confirm = ref(false);
        var fillingStage = ref(false);
        var alreadyExist = ref(false);
        var applicationStatus = ref('');
        onMounted(function () { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!tariffIsStopped.value) {
                            if (authStore.user && ((_a = authStore.user) === null || _a === void 0 ? void 0 : _a.uin.length) > 0 || localStorage.getItem('token'))
                                router.push('/');
                        }
                        return [4 /*yield*/, getApplicationStatus()];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        }); });
        var getApplicationStatus = function () { return __awaiter(_this, void 0, void 0, function () {
            var response;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!((_a = telegramStore.telegramUser) === null || _a === void 0 ? void 0 : _a.id)) return [3 /*break*/, 2];
                        return [4 /*yield*/, checkApplication(telegramStore.telegramUser.id)];
                    case 1:
                        response = _b.sent();
                        if (response.status === 200) {
                            if (response.data.status === 'Создано')
                                router.push('/');
                            alreadyExist.value = true;
                            applicationStatus.value = response.data.status;
                        }
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        var getApplicationMessage = computed(function () {
            if (tariffIsStopped.value) {
                return 'Вы приостановили членство в клубе';
            }
            if (applicationStatus.value === 'Новое') {
                return 'Ваши ответы отправлены администратору клуба. Скоро Вам придет его решение';
            }
            else if (applicationStatus.value === 'Отклонено') {
                return 'К сожалению вам отказано в доступе к закрытому клубу. <br> <span>По всем вопросам Вы можете обратиться к администратору</span>';
            }
            else if (applicationStatus.value === 'Одобрено') {
                return 'Вам одобрен доступ к закрытому клубу!<br>Теперь вы можете оформить подписку.';
            }
            return '';
        });
        var tariffIsStopped = computed(function () {
            return authStore.user && authStore.user.userTariff.status === 'Приостановлен';
        });
        var handleApplicationSent = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        fillingStage.value = false;
                        alreadyExist.value = true;
                        return [4 /*yield*/, getApplicationStatus()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        var handleSubscription = function () {
            router.push('/tariff');
        };
        var handleResumeTariff = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, stopUserTariff()];
                    case 1:
                        _a.sent();
                        router.push('/');
                        return [2 /*return*/];
                }
            });
        }); };
        return function (_ctx, _cache) {
            var _component_el_image = _resolveComponent("el-image");
            var _component_ElButton = _resolveComponent("ElButton");
            var _component_el_checkbox = _resolveComponent("el-checkbox");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (!fillingStage.value)
                    ? (_openBlock(), _createBlock(ApplicationHeader, { key: 0 }))
                    : _createCommentVNode("", true),
                (alreadyExist.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createElementVNode("p", {
                            class: "application__exist-page-info",
                            innerHTML: getApplicationMessage.value
                        }, null, 8, _hoisted_3),
                        (!tariffIsStopped.value)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (applicationStatus.value === 'Новое')
                                    ? (_openBlock(), _createElementBlock("a", _hoisted_4, [
                                        _cache[3] || (_cache[3] = _createTextVNode(" Сайт клуба Barganets ")),
                                        _createElementVNode("div", _hoisted_5, [
                                            _createVNode(_component_el_image, { src: _unref(arrowTopRight) }, null, 8, ["src"])
                                        ])
                                    ]))
                                    : _createCommentVNode("", true),
                                (applicationStatus.value === 'Одобрено')
                                    ? (_openBlock(), _createBlock(_component_ElButton, {
                                        key: 1,
                                        class: "application__exist-page-button accept-button",
                                        color: "#013766",
                                        size: "large",
                                        onClick: handleSubscription
                                    }, {
                                        default: _withCtx(function () { return _cache[4] || (_cache[4] = [
                                            _createTextVNode(" Оформить подписку ")
                                        ]); }),
                                        _: 1
                                    }))
                                    : _createCommentVNode("", true)
                            ], 64))
                            : (_openBlock(), _createBlock(_component_ElButton, {
                                key: 1,
                                class: "application__exist-page-button accept-button",
                                color: "#013766",
                                size: "large",
                                onClick: handleResumeTariff
                            }, {
                                default: _withCtx(function () { return _cache[5] || (_cache[5] = [
                                    _createTextVNode(" Возобновить доступ ")
                                ]); }),
                                _: 1
                            }))
                    ]))
                    : (!startFilling.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _cache[7] || (_cache[7] = _createElementVNode("p", { class: "application__banner-title" }, "Barganets", -1)),
                            _createElementVNode("img", {
                                class: "application__banner-image",
                                src: _unref(bannerImage)
                            }, null, 8, _hoisted_7),
                            _createVNode(_component_ElButton, {
                                class: "application__banner-button accept-button",
                                color: "#013766",
                                size: "large",
                                onClick: _cache[0] || (_cache[0] = function ($event) { return (startFilling.value = !startFilling.value); })
                            }, {
                                default: _withCtx(function () { return _cache[6] || (_cache[6] = [
                                    _createTextVNode(" Вступить ")
                                ]); }),
                                _: 1
                            })
                        ]))
                        : ((startFilling.value && !fillingStage.value))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                _cache[10] || (_cache[10] = _createElementVNode("p", { class: "application__start-page-info" }, "Для того, чтобы вступить в клуб Вам нужно пройти небольшой опрос", -1)),
                                _createVNode(_component_ElButton, {
                                    class: "application__start-page-button accept-button",
                                    color: "#013766",
                                    disabled: !confirm.value,
                                    onClick: _cache[1] || (_cache[1] = function ($event) { return (fillingStage.value = true); })
                                }, {
                                    default: _withCtx(function () { return _cache[8] || (_cache[8] = [
                                        _createTextVNode(" Продолжить ")
                                    ]); }),
                                    _: 1
                                }, 8, ["disabled"]),
                                _createElementVNode("div", _hoisted_9, [
                                    _createVNode(_component_el_checkbox, {
                                        modelValue: confirm.value,
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) { return ((confirm).value = $event); }),
                                        size: "large"
                                    }, null, 8, ["modelValue"]),
                                    _cache[9] || (_cache[9] = _createElementVNode("p", null, "Я согласен с условиями публичной оферты и обработки личных данных", -1))
                                ])
                            ]))
                            : (fillingStage.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                    _createVNode(ApplicationTabs, { onApplicationSent: handleApplicationSent })
                                ]))
                                : _createCommentVNode("", true)
            ]));
        };
    }
});
